<script lang="ts">
import type { CombinedError } from '@urql/vue';
import {
  computed, defineComponent, toRaw,
} from 'vue';
import { any, object } from 'vue-types';
import { Alert } from 'ant-design-vue';

import ValidationErrors from './ValidationErrors.vue';
import parseError from './parseError';

export default defineComponent({
  name: 'AlertError',
  components: {
    Alert,
    ValidationErrors,
  },
  props: {
    error: object<CombinedError>(),
    class: any(),
    removeClass: Boolean,
  },
  setup(properties) {
    const errors = computed(() => {
      const rawErrors = toRaw(properties.error);
      return rawErrors?.graphQLErrors && rawErrors.graphQLErrors.length > 0
        ? rawErrors.graphQLErrors[0]
        : undefined;
    });

    const messageError = computed(() => parseError(errors.value));
    const validationError = computed(
      () => errors.value?.extensions?.validation as Record<string, string[]>,
    );
    return {
      messageError,
      validationError,
    };
  },
});
</script>

<template>
  <div :class="$props.class">
    <Alert
      type="error"
      show-icon
    >
      <template #description>
        <ValidationErrors v-if="validationError" :errors="validationError" />
        <div v-else>
          {{ messageError }}
        </div>
      </template>
    </Alert>
  </div>
</template>
